import React, { Component } from 'react';
import { func } from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Translate } from 'react-localize-redux';
import Pagination from '../Pagination';
import { langType, withLang } from '../../i18n';
import frontPageStyles from '../FrontPage/frontPage.module.css';
import { getAuditEventsPage } from '../../api';
import {
  API_DATE_FORMAT, EMPTY_PAGE, LONG_DISPLAY_DATE_FORMAT, sortDirections
} from '../../constants';
import { addErrorMessageAction, setTaskFulfilled, setTaskPending } from '../../actions';
import { getLocalizedText, setDocumentTitle, stringifyURLParams } from '../../util';
import styles from './activityLog.module.css';
import withRouter from '../WithRouter';

const EVENTS_PER_PAGE = 10;

const SORT_COLUMNS = {
  createdAt: 'createdAt',
  lastName: 'lastName'
};

const getSearchParams = (page, optionalParameters) =>
  `?${stringifyURLParams({ page, ...optionalParameters })}`;

class ActivityLog extends Component {
  constructor(props) {
    super(props);
    this.getPage = this.getPage.bind(this);
    this.sortCriteriaChanged = this.sortCriteriaChanged.bind(this);
    this.renderAuditEvent = this.renderAuditEvent.bind(this);
    this.state = {
      query: {
        sortBy: SORT_COLUMNS.createdAt,
        sortDir: sortDirections.ASCENDING
      },
      auditEventsPage: EMPTY_PAGE
    };
  }

  componentDidMount() {
    this.getPage(0);
  }

  getPage(page) {
    const {
      dispatchAddErrorMessage, dispatchSetTaskPending, dispatchSetTaskFulfilled
    } = this.props;

    const { sortBy, sortDir } = this.state.query;

    dispatchSetTaskPending();
    getAuditEventsPage(page, EVENTS_PER_PAGE, sortBy, sortDir)
      .then((auditEventsPage) =>
        this.setState({ auditEventsPage }, () => {
          this.props.navigate({
            search: getSearchParams(page, { sortBy, sortDir })
          }, { replace: true });
        }))
      .catch(dispatchAddErrorMessage)
      .finally(dispatchSetTaskFulfilled);
  }

  sortCriteriaChanged(param) {
    const actualParams = {};
    const { sortBy } = this.state.query;

    if (param === sortBy) {
      actualParams.sortDir = this.state.query.sortDir === sortDirections.ASCENDING
        ? sortDirections.DESCENDING
        : sortDirections.ASCENDING;
      actualParams.sortBy = sortBy;
    } else {
      actualParams.sortBy = param;
      actualParams.sortDir = sortDirections.ASCENDING;
    }
    this.setState({ query: actualParams }, () => this.getPage(0));
  }

  renderHeader(sortColumnName, translationKey) {
    const { sortDir, sortBy } = this.state.query;
    let classForHeader = '';
    if (sortColumnName === sortBy) {
      classForHeader = sortDir === sortDirections.ASCENDING ? 'icon--link-arrow-up' : 'icon--link-arrow-down';
    }
    return (
      <th
        className={`${classForHeader} ${styles.sortableHeader}`}
        onClick={() => this.sortCriteriaChanged(sortColumnName)}
      >
        <Translate id={translationKey} />
      </th>
    );
  }

  renderAuditEvent(event) {
    const { lang, translate: t } = this.props;
    const {
      commonName,
      createdAt,
      operation,
      exportReason,
      surveyName
    } = event;

    return (
      <tr key={createdAt}>
        <td>{commonName}</td>
        <td>{t(`activityLog.${operation}`)}</td>
        <td>{getLocalizedText(surveyName, lang)}</td>
        <td>{exportReason}</td>
        <td>{moment(createdAt, API_DATE_FORMAT).format(LONG_DISPLAY_DATE_FORMAT)}</td>
      </tr>
    );
  }

  renderPagination() {
    const {
      number, totalPages, first, last
    } = this.state.auditEventsPage;

    return (
      <Pagination
        navFunction={this.getPage}
        number={number}
        totalPages={totalPages}
        first={first}
        last={last}
      />
    );
  }

  render() {
    const { content } = this.state.auditEventsPage;
    const { translate: t } = this.props;

    setDocumentTitle(`${t('adminTools.title')} - ${t('activityLog.activityLog')}`);

    return (
      <div className={frontPageStyles.content}>
        <h1 className="panel__title">{t('activityLog.activityLog')}</h1>
        <table className="table-simple">
          <thead>
            <tr>
              {this.renderHeader(SORT_COLUMNS.lastName, 'common.name')}
              <th className={styles.header}>{t('activityLog.action')}</th>
              <th className={styles.header}>{t('common.survey')}</th>
              <th className={styles.header}>{t('activityLog.exportReason')}</th>
              {this.renderHeader(SORT_COLUMNS.createdAt, 'common.dateTime')}
            </tr>
          </thead>
          <tbody>
            {content.map((auditEvent) => this.renderAuditEvent(auditEvent))}
          </tbody>
        </table>
        {this.renderPagination()}
      </div>
    );
  }
}

ActivityLog.propTypes = {
  navigate: func.isRequired,
  dispatchAddErrorMessage: func.isRequired,
  dispatchSetTaskPending: func.isRequired,
  dispatchSetTaskFulfilled: func.isRequired,
  ...langType
};

const mapDispatchToProps = (dispatch) => ({
  dispatchAddErrorMessage: (err) => dispatch(addErrorMessageAction(err)),
  dispatchSetTaskPending: () => dispatch(setTaskPending()),
  dispatchSetTaskFulfilled: () => dispatch(setTaskFulfilled())
});

export default withLang(withRouter(connect(null, mapDispatchToProps)(ActivityLog)));
